import React from 'react';
import { Dialog,Box, Button} from '@mui/material';
import { styled } from '@mui/material/styles'; 
import { useNavigate } from 'react-router';

import { displayFont } from "../theme";
import { tokens } from "../theme";
const TextBox = styled(Box)({
    display: "block",
});

function DeleteWarning({open, onClose, redirectLink}) {
  
  const navigate = useNavigate();

  const handleDelete = () =>{
      navigate(redirectLink);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "10px",
          padding: "0.75rem 1rem",
          display:"flex",
          flexDirection:"column",
          alignItems:"center",
          gap: "1rem",
        }
      }}
    >
            <TextBox sx={{fontWeight: 600, fontFamily: displayFont, fontSize: "1.25rem", lineHeight: 1.3}}>
               Are you sure you want to delete?
            </TextBox>
            <TextBox sx={{fontSize: "1rem", lineHeight: 1.7}}>
               This item will be deleted immediately. You can't undo this action.
            </TextBox>
            <Box sx={{ display: "flex", justifyContent: "end", gap: "1rem", marginBlock: "2rem" }}>
                  <Button 
                    onClick={handleDelete} 
                    sx={{
                      width:"6.25rem", 
                      height: '3rem', 
                      padding: '1.25rem', 
                      borderRadius: '10px', 
                      textAlign: "center",
                      textTransform: "none", 
                      bgcolor:tokens.danger,
                      color:tokens.onPrimary,
                      border:`1px solid ${tokens.danger}`,
                      "&:hover":{
                        color:tokens.danger,
                        bgcolor:tokens.card,
                      }
                  }}>
                      Delete
                </Button>
                <Button 
                    onClick={onClose} 
                    sx={{
                      width:"6.25rem", 
                      height: '3rem', 
                      padding: '1.25rem', 
                      borderRadius: '10px', 
                      textAlign: "center",
                      textTransform: "none", 
                      color:tokens.danger,
                      bgcolor:tokens.card,
                      border:`1px solid ${tokens.danger}`,
                      "&:hover":{
                        bgcolor:tokens.danger,
                        color:tokens.onPrimary,
                      }
                  }}>
                      Cancel
                </Button>
            </Box>
    </Dialog>
  );
}

export default DeleteWarning;

